export default "__VITE_ASSET__CwfWCIGU__"